import React from 'react';

const Welcome = () => {
    return (
        <div className=" h-screen font-bold -mt-5 uppercase text-4xl flex justify-center items-center">
            welcome to dashboard
        </div>
    );
};

export default Welcome;